import { useEffect, useState } from 'react';
import { 
    Box, 
    CircularProgress, 
} from '@mui/material';
import api from 'state/axios';
import DynamicField from './DynamicField';

const DynamicForm = ({
    fields = [],
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    disabled = false,
}) => {
    const [resolvedOptions, setResolvedOptions] = useState({});
    const [optionsLoading, setOptionsLoading] = useState(false);

    useEffect(() => {
        const relationFields = fields.filter(
            f => (f.type === 'relation') && f.optionsFrom && f.showInForm
        );
        if (!relationFields.length) return;

        const fetchOptions = async () => {
            setOptionsLoading(true);
            const results = await Promise.allSettled(
                relationFields.map(f =>
                    api.get(f.optionsFrom).then(res => ({
                        name: f.name,
                        data: res.data,
                        valueKey: f.optionsValue || '_id',
                        labelKey: f.optionsLabel || 'name',
                    }))
                )
            );

            const map = {};
            results.forEach(r => {
                if (r.status === 'fulfilled') {
                    const { name, data, valueKey, labelKey } = r.value;
                    const list = Array.isArray(data) ? data : data?.data || [];
                    map[name] = list.map(item => ({
                        value: item[valueKey],
                        label: item[labelKey] ?? item[valueKey],
                    }));
                }
            });
            setResolvedOptions(map);
            setOptionsLoading(false);
        };

        fetchOptions();
    }, [fields]);

    const visibleFields = fields
        .filter(f => f.showInForm)
        .sort((a, b) => a.order - b.order);

    if (optionsLoading) {
        return (
            <Box display="flex" justifyContent="center" p={2}>
                <CircularProgress size={24} />
            </Box>
        );
    }

    return (
        <Box
            display="grid"
            gridTemplateColumns="repeat(12, minmax(0, 1fr))"
            gap={2}
        >
            {visibleFields.map(field => (
                <DynamicField
                    key={field._id || field.name}
                    field={field}
                    value={values[field.name]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched[field.name] && errors[field.name]}
                    helperText={touched[field.name] && errors[field.name]}
                    disabled={disabled}
                    resolvedOptions={resolvedOptions[field.name] || []}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    errors={errors}
                />
            ))}
        </Box>
    );
};

export default DynamicForm;
